import React from "react";
import { connect } from "react-redux";
import { Tab, Small } from "evergreen-ui";

class ActivitiesBar extends React.Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    const activityElement = document.getElementById(
      `activity-${this.props.selectedActivityIndex}`
    );
    const nextActivityElement = document.getElementById(
      `activity-${this.props.selectedActivityIndex + 1}`
    );
    if (activityElement) {
      const scrollOptions = {
        behavior: "smooth",
      };
      activityElement.scrollIntoView(scrollOptions);
      nextActivityElement && nextActivityElement.scrollIntoView(scrollOptions);
    }
  }

  render() {
    const { activityData, selectedActivityIndex, activityChange } = this.props;

    return (
      <div className={"activities-container"}>
        {activityData &&
          activityData["activities"] &&
          Object.keys(activityData["activities"]).map((activity, index) => {
            return (
              <div
                id={`activity-${index}`}
                key={index}
                className={"activity-item"}
              >
                <Tab
                  aria-controls={`panel-${activity}`}
                  borderBottom={
                    index === selectedActivityIndex ? "4px solid white" : ""
                  }
                  color={"white"}
                  padding={0}
                  alignContent={"center"}
                  margin={0}
                  onSelect={() => activityChange(index)}
                  height={40}
                >
                  <Small>{activityData["activities"][activity]}</Small>
                </Tab>
              </div>
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = ({ activityData }) => ({
  activityData,
});

export default connect(mapStateToProps)(ActivitiesBar);
